import { initializeLogger } from '@seamless/logger';
export const logger = initializeLogger('FSS-INPUT');
export type Logger = typeof logger;
